import React, { Component } from 'react'

export default class About extends Component {
  render() {
    return (
      <div className="center">
        <h2>
          These books are the best for learning the language, but there are also
          YouTube and many channels that explain JavaScript in a distinctive and
          professional way
        </h2>
      </div>
    );
  }
}
